import { Pipe, PipeTransform, inject } from '@angular/core';
import { CategoriesMasterService } from '@core/services/masters/categories-master.service';
import { Observable, map, of } from 'rxjs';

@Pipe({
  name: 'categoryName',
  pure: false, // We need impure pipe because we're using async operations
})
export class CategoryNamePipe implements PipeTransform {
  private categoriesMasterService = inject(CategoriesMasterService);

  transform(categoryId: string): Observable<string> {
    if (!categoryId) {
      return of('');
    }

    return this.categoriesMasterService.getCategory(categoryId).pipe(
      map((category) => {
        return category?.name || '';
      }),
    );
  }
}
